const PROD_CLOUD_URL = 'applex.cloud.imprivata.com';
const PROD_SSDM_URL = 'ssdm.cloud.imprivata.com';

export function load(config) {

  console.log('Remote Access embed script loaded.');

  const thisScript = document.querySelector('script[data-access-token]');

  if (!thisScript) {
    console.error('Missing access token');
    return;
  }

  const errorText = document.querySelector(config.errorSelector);
  if (errorText != null) {
    console.log('Not rendering UI because a VPN native error exists already');
    return;
  }

  if (hideCookieExists() ) {
    removeHideCookie();
    console.log('Not rendering UI because the ImprHide cookie is present.');
    return;
  }

  // For text mode where "Try another way" uses a cookie rather than URL change
  if (document.querySelector(config.secondFieldSelector) == null) {
    console.log('Not rendering UI because second field does not exist.');
    return;
  }

  const accessToken = thisScript.getAttribute('data-access-token');
  let cloudauthEnvironmentUrl = thisScript.getAttribute('data-cloudauthEnv');
  let selfServiceEnvironment = thisScript.getAttribute('data-selfServiceEnv');

  const scriptHost = getHost(thisScript);
  const scriptHostname = getHostname(thisScript);

  if (cloudauthEnvironmentUrl) {
    console.log('Overriding environment URL with data-cloudauthEnv attribute.');
  }
  else {
    cloudauthEnvironmentUrl = getCloudauthEnvironmentUrl(scriptHostname);
  }

  if (selfServiceEnvironment) {
    console.log('Overriding environment URL with data-cloudauthEnv attribute.');
  }
  else {
    selfServiceEnvironment = getSelfServiceEnvironmentUrl(scriptHostname);
  }

  // Hide VPN Login form
  hideVpnLoginForm(config);

  config.prepare();

  const prepopulatedCredentials = getPrepopulatedCredentials(config);

  // Display CIDRA UI
  render_CIDRA_UI(config, scriptHost, accessToken, cloudauthEnvironmentUrl, selfServiceEnvironment,
    prepopulatedCredentials.username, prepopulatedCredentials.password);

  config.finalize();

  let receiveMessage = (event) => {
    if (event.data.username != null) {

      let firstField = document.querySelector(config.firstFieldSelector);
      let secondField = document.querySelector(config.secondFieldSelector);
      let thirdField = document.querySelector(config.thirdFieldSelector);

      if (firstField) {
        firstField.value = event.data.username;
      }
      if (secondField && thirdField) {
        secondField.value = event.data.password;
        thirdField.value = event.data.authenticationToken;
      }
      else if (secondField) {
        secondField.value = event.data.authenticationToken;
      }

      config.submit();

    }
    else if (event.data.exit) {
      config.hide();

    }
    else {
      // Embed script received unknown event
    }
  };

  // Submit hidden form when we receive a message from the UI
  if (window.addEventListener) {
    window.addEventListener('message', receiveMessage, false);
  }
}

/**
 * Gets any prepopulated credentials which might already be in username
 * and password fields on the page.
 * 
 * @param {*} config the configuration object specific for a gateway
 */
export function getPrepopulatedCredentials(config) {
  let username;
  let password;

  const firstField = document.querySelector(config.firstFieldSelector);
  const secondField = document.querySelector(config.secondFieldSelector);

  if (firstField) {
    username = firstField.value;
  }
  if (secondField) {
    password = secondField.value;
  }

  return { username, password, };
}

/**
 * Removes hide cookie. On future logins, the UI will be displayed, not hidden.
 */
function removeHideCookie() {
  document.cookie = 'ImprHide=0';
}

/**
 * Gets hide cookie, which tells the UI not to draw itself.
 * The cookie is set with the "Try another way" button.
 */
function hideCookieExists() {
  return document.cookie.split(';').filter( (item) =>
    item.indexOf('ImprHide=1') > -1
  ).length > 0;
}

/**
 * Gets the host (including port) where a script is being served from
 * @param {string} script - The script
 */
function getHost(script) {
  const parser = document.createElement('a');
  parser.href = script.src;
  return parser.host;
}

/**
 * Gets the hostname (not including port) where a script is being served from
 * @param {string} script - The script
 */
function getHostname(script) {
  const parser = document.createElement('a');
  parser.href = script.src;
  return parser.hostname;
}

/**
 * Gets the cloud environment URL from the UI URL
 * Currently replaces the first segment of the hostname with "applex"
 * e.g. for the integration environment, cidra.integration.common.imprivata.com 
 *      returns applex.integration.common.imprivata.com
 */
function getCloudauthEnvironmentUrl(scriptUrl) {
  let splitScriptUrl = scriptUrl.split('.');

  if (splitScriptUrl.length > 1) {
    splitScriptUrl[0] = 'applex';
    const CLOUD_URL = splitScriptUrl.join('.');

    return CLOUD_URL;
  }
  else {
    return PROD_CLOUD_URL;
  }
}

/**
 * Gets the self-service environment URL from the UI URL
 * Currently replaces the first segment of the hostname with "applex"
 * e.g. for the integration environment, cidra.integration.common.imprivata.com 
 *      returns applex.integration.common.imprivata.com
 */
function getSelfServiceEnvironmentUrl(scriptUrl) {
  let splitScriptUrl = scriptUrl.split('.');

  if (splitScriptUrl.length > 1) {
    splitScriptUrl[0] = 'ssdm';
    const SSDM_URL = splitScriptUrl.join('.');

    return SSDM_URL;
  }
  else {
    return PROD_SSDM_URL;
  }
}

/**
 * Hides the VPN's login form according to the selectors in the config
 * 
 * @param {object} config the configuration object specific for a gateway
 */
function hideVpnLoginForm(config) {
  let hideSelector = config.hideSelector == null ? config.vpnFormSelector : config.hideSelector;
  const formTable = document.querySelector(hideSelector);

  if (formTable) {
    formTable.style.display = 'none';
  }
}

/**
 * Renders the UI according to the selectors in the config
 * 
 * @param {object} config the configuration object specific for a gateway
 * @param {*} scriptHost where this script is hosted (used to determine the cloud if it is not overridden)
 * @param {*} accessToken the token which is used to connect to the cloud
 * @param {*} cloudauthEnvironment the URL to the cloudauth cluster
 * @param {*} selfServiceEnvironment the URL to the self service microservice
 * @param {*} populatedUsername the username that already was in the underlying field, if any
 * @param {*} populatedPassword the password that already was in the underlying field, if any
 */
function render_CIDRA_UI(config, scriptHost, accessToken, cloudauthEnvironment, selfServiceEnvironment,
  populatedUsername = '', populatedPassword = '') {

  let iframe = document.createElement('iframe');
  iframe.name = 'imprivata_remote_access_frame';
  iframe.width = config.width;
  iframe.height = config.height;
  iframe.src = '//' + scriptHost + '/';
  iframe.frameBorder = 0;
  iframe.style.backgroundColor = 'transparent';
  iframe.allowTransparency = 'true';

  let interiorContainer = document.createElement('div');
  let node = interiorContainer.appendChild(iframe);

  const container = document.querySelector(config.containerSelector);
  container.appendChild(interiorContainer);

  node.onload = function() {
    node.contentWindow.postMessage({
      accountToken: accessToken,
      cloudauthEnvironment: cloudauthEnvironment,
      selfServiceEnvironment: selfServiceEnvironment,
      populatedUsername,
      populatedPassword,
    }, '*');
  };
}
